const TECHNICAL_SUFFIX_PATTERN = /_[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$|_[0-9a-f]{8,}$/i

export default function getCleanDisplayTitle(title: string): string {
  return title
    .replace(TECHNICAL_SUFFIX_PATTERN, '')
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}
